import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { Dispatch } from 'redux';
import { RootState } from '../../stores/store';
import { search, clearSelection } from '../../stores/tables/actionCreators';
import { selected } from '../../stores/tables/selectors';

interface Props extends LocalizeContextProps {
    tableKey: string;
    refresh: () => void;

    search: (str: string) => void;
    clearSelection: () => void;
    selectionCount: number;
}

interface State {
    search: string;
}

class TableSearch extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            search: '',
        };
    }

  private SelectionMessage = () => {
        const t = this.props.translate;
        if (this.props.selectionCount > 0) {
            return (
              <div className='inputCount my-1'>
                {this.props.selectionCount} {t('users.field.selected')} <a onClick={this.props.clearSelection} className="underline">({t("users.field.unselect")})</a>
              </div>
            );
        } 
        return <div className='inputCount my-1'></div>
    }

    public render() {
        const t = this.props.translate;
        return (
          <div>
            <InputGroup className='form-group noMarginBottom'>
              <InputGroupAddon addonType='prepend'>
                <span className='input-group-text'>
                  <FontAwesomeIcon
                    icon={['fal', 'search']}
                    className='noMarginRight'
                  />
                </span>
              </InputGroupAddon>
              <Input
                onChange={this.handleInputChange}
                value={this.state.search}
                name='search'
                id='table-search'
                type='text'
                placeholder={t('users.field.search') as string}
              />
              <InputGroupAddon addonType='append'>
                <Button
                  style={{ outline: 'none' }}
                  onClick={() => {
                    this.props.search('');
                    this.props.refresh();
                    this.setState({ search: '' });
                    $('#table-search').focus();
                  }}>
                  <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className='noMarginRight'
                  />
                </Button>
              </InputGroupAddon>
            </InputGroup>
            <this.SelectionMessage/>
          </div>
        );
    }

  private handleInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputString = event.target.value;
    this.setState({
      search: inputString,
    });
    await new Promise(resolve => setTimeout(resolve, 500));
    if (this.state.search === inputString) {
      this.props.search(inputString);
      this.props.refresh();
    }
  }
}

const mapStateToProps = (state: RootState, props: { tableKey: string }) => ({
    selectionCount: selected(state, props.tableKey).length,
});

const mapDispatchToProps = (dispatch: Dispatch, props: { tableKey: string }) => ({
    search: (str: string) => dispatch(search(props.tableKey, str)),
    clearSelection: () => dispatch(clearSelection(props.tableKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(TableSearch));